import MUIDataTable from 'mui-datatables'
import TableHeader from './components/TableHeader'
import { leavesTableData, leavesTableSelectedUserData } from './utils/tableData'
import { leavesTableColumns, leavesTableOptions, leavesTableSelectedUserColumns } from './utils/tableUtils'
import { EPermissionsKeys } from '../Layout/permissionEnums'
import { isLimitedLeaveViewerOnly } from './utils/limitedLeaveAccess'

const LeavesDataTable = ({ thisObject }) => {
  const hasExportPermission = thisObject?.props?.userStore?.permissionsKeys?.includes(EPermissionsKeys.ALLOWED_TO_EXPORT_LEAVE_DOCUMENTS)
  const isReadOnly = isLimitedLeaveViewerOnly(thisObject?.props?.userStore)

  const tableColumns = thisObject?.state?.selectedUserID
    ? leavesTableSelectedUserColumns({ ...thisObject?.state, isLimitedLeaveViewerOnly: isReadOnly })
    : leavesTableColumns({ ...thisObject?.state, hasExportPermission, isLimitedLeaveViewerOnly: isReadOnly })

  const newData = thisObject?.state?.dataTableData.map((oneLeave) =>
    thisObject?.state?.selectedUserID ? leavesTableSelectedUserData(oneLeave, thisObject) : leavesTableData(oneLeave, thisObject)
  )

  const tableOptions = leavesTableOptions(thisObject)

  return (
    <div className={thisObject?.state?.dataTableDataLoading ? 'whirl standard' : null}>
      <MUIDataTable columns={tableColumns} options={tableOptions} data={newData} title={<TableHeader thisObject={thisObject} />} />
    </div>
  )
}

export default LeavesDataTable
